module.exports = __webpack_public_path__ + "img/2.3a3410d7.jpg";